import React from "react";
import styles from "./Hero.module.css";
import {
  FaHandshake,
  FaArrowRight,
  FaSchool,
  FaGlobe,
  FaUserTie,
  FaMapMarkedAlt,
  FaHistory,
} from "react-icons/fa";

const Hero = () => {
  const quickStats = [
    { icon: <FaHandshake />, value: "55+", label: " Partners" },
    { icon: <FaGlobe />, value: "Quick", label: "ROI" },
    { icon: <FaUserTie />, value: "Low", label: "Investments" },
    { icon: <FaHistory />, value: "FutureProof", label: "Business" },
  ];

  const handleContactClick = () => {
    const formElement = document.getElementById("cta-form");
    formElement?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={styles.hero}>
      <div className={styles.content}>
        <div className={styles.mainContent} data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="100">
            STEMx Channel Partners
            <span
              className={styles.highlight}
              data-aos="fade-up"
              data-aos-delay="150"
            >
              {" "}
              A leading center for robotics, electronics, 3D printing, and drone
              technology.
            </span>
          </h1>
          <p data-aos="fade-up" data-aos-delay="200">
            Join us in transforming the future of education with innovative STEM
            learning solutions for school students. Are you interested in
            starting your own business in the school market focused on robotics,
            AI, and STEM? With STEMx, your entrepreneurial journey becomes
            seamless, thanks to the comprehensive support we offer, along with
            low investment and promising returns on investment (ROI).
          </p>
          <div
            className={styles.buttons}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <button className={styles.primary}>
              Partner with Us <FaHandshake className={styles.icon} />
            </button>
            <button className={styles.secondary} onClick={handleContactClick}>
              Contact Us <FaArrowRight className={styles.icon} />
            </button>
          </div>
        </div>
      </div>

      <div className={styles.statsGrid}>
        {quickStats.map((stat, index) => (
          <div key={index} className={styles.quickStat}>
            <div className={styles.statIcon}>{stat.icon}</div>
            <div className={styles.statValue}>{stat.value}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hero;
